/**
 * Konstanten für externe System-URLs (read-only Verknüpfung).
 *
 * `VITE_INVOICE_NINJA_URL` kann über .env überschrieben werden, Default
 * ist die Produktiv-Instanz aus der Recherche-Doku
 * (`Planung/01-Recherche/invoice-ninja-erkundung.md`).
 */

const IN_BASE = (
  import.meta.env.VITE_INVOICE_NINJA_URL ?? 'https://office.itkaufmann.at'
).replace(/\/$/, '');

export function invoiceNinjaRecurringUrl(invoiceNinjaId: string): string {
  return `${IN_BASE}/recurring_invoices/${encodeURIComponent(invoiceNinjaId)}/edit`;
}

export function invoiceNinjaClientUrl(clientId: string): string {
  return `${IN_BASE}/clients/${encodeURIComponent(clientId)}`;
}
